module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/auth/login/login.component.scss
// module id = ./src/app/routes/auth/login/login.component.scss
// module chunks = main